import store from '@/store'
import uemPageConfig from '@/utils/UEM/UEM_page_config'
import uemCapability from '@/utils/UEM/UEM_capability'
import roleCheck from '@/utils/role_privilege_check.js'
import * as loadGlobal from '@/utils/loadingOpt.js'
import { __setExhiType, __setFunctionEnableByExhiType, __setOrderEnable, __setFunctionEnableByResourceSwitch } from '@/utils/exhibitionInfo.js'

const getExhiConfig = function(to) {
    return new Promise((resolve, reject) => {
        let exhiId = to.query.exhiId
        let loadedExid = store.state.common.exhiId
        // 如果URL上带有exhid 且 ID对应的展会信息没有查询出来或与已经存在的ID不一至时重新查对应的展会信息
        if (!exhiId || exhiId === loadedExid || to.path === 'exhiDetail' || to.path === 'exhiInfo') {
            resolve()
        } else {
            store.dispatch('common/getExhiConfig', { exhiId }).then(data => {
                // 清空功能启用信息
                store.commit('switchConfigStore/clearFuncEnable')
                let exhiType = __setExhiType(data)
                __setFunctionEnableByExhiType(exhiType)
                if (to.path !== '/config/switchConfig') {
                    store.dispatch('switchConfigStore/getResourceSwitchAct', { exhiId, exhiFrom: store.state.common.exhiConfig.exhiFrom }).then((res) => {
                        if (res.data.data) {
                            __setFunctionEnableByResourceSwitch(res.data.data)
                        }
                        resolve(data)
                    })
                    store.dispatch('switchConfigStore/getOrderExistsAct', { exhiId, exhiFrom: store.state.common.exhiConfig.exhiFrom }).then((res) => {
                        if (res.data.data) {
                            __setFunctionEnableByResourceSwitch(res.data.data)
                            __setOrderEnable(res.data.data)
                        }
                    })
                } else {
                    resolve(data)
                }
            })
        }
    });
}

/**
 * 拦截器里面统一做页面埋码
 * @param {*} to 到达页面的路由path
 */
const trackUEM = function(to) {
    // 如果是媒体模块，需要单独执行appkey, 仅用于埋码
    let envPath = process.env.VUE_APP_BUILD_ENV
    // 执行初始化的页面, 仅用于埋码
    let appkey = envPath === 'prod' ? '051e129f1d304b6ea5df93796022d3a0' : 'efd3450359ecf96794882b10cdb5772e'
    window.hwa('setAppId', appkey)

    uemPageConfig.forEach((item) => {
        if (Object.prototype.toString.call(item['reg']) === '[object RegExp]' && item['reg'].test(to.fullPath)) {
            uemCapability.trackPageView(item.pageCode)
            return true
        }
    })
}

/**
 *
 * @param {to} 路由预到达的信息
 * 如果打开的是首页，清除store里面存储的展会信息
 */
const clearStoreExhiInfo = function(to) {
    if (to.name === 'home') {
        store.commit('common/setExhiConfigInfo', {})
        store.commit('common/setCompanyPer', { isLoaded: false, isOwn: false })
        store.commit('common/setVehiclePer', { isLoaded: false, isOwn: false })
    }
}

/**
 * @name {} 进入路由的时候，默认先将面包屑隐藏起来
 */
const hideBreadcrumbData = function(to, from) {
    // 因为每次点击el-menu时都会触发这个方法，而路由不变时，对应的组件是不重新渲染的，导致重复点击相同的路由时，只有第一次组件渲染时会触发组件内部的展示面包屑方法，之后面包屑会被隐藏
    if (to.name !== from.name) {
        store.commit('common/setBreadcrumbData', { data: [], isHide: true })
    }
}

/** 获取是否允许通过的结果 */
const getPass = async(premCode, isSysOrExhibitManage) => {
    let pass = true
    if (premCode === 'NOTTOURISTS') { // 游客不能访问meta标志
        pass = !(await roleCheck.isTourists())
    }
    return pass
}
export default function(router) {
    router.beforeEach(async (to, from, next) => {
        try {
              // 进入路由先就面包屑隐藏，防止组件中未处理也未用到，导致面包屑显示出来了
            hideBreadcrumbData(to, from)
            // 进入页面进行，根据路由的path 进行页面埋码处理
            trackUEM(to)
            // 进入展会首页，清空存储在store里面的展会信息
            clearStoreExhiInfo(to)
            await getExhiConfig(to).catch(err => {
                console.error('获取展会信息失败:', err);
            });

            const isSysOrExhibitManage = roleCheck.judgmentIsSystemAdmin() || // 系统管理员
                                         roleCheck.judgmentIsExhiMange() || // 展会配置管理员
                                         store.state.common.onlyCheckInStaff; // 签到工作人员

            const premCode = to.meta.prem;
            const pass = await getPass(premCode, isSysOrExhibitManage);

            if (pass) {
                // 2. 修正自动补齐 exhiId 的选择，防止死循环
                const currentExhiId = store.state.common.exhiId;
                if (to.name !== 'home' && !to.query.exhiId && currentExhiId) {
                    // 如果已经进入展会，而跳转地址没有带exhiId的query入参，再次统一加上
                    return next({
                        ...to,
                        query: { ...to.query, exhiId: currentExhiId },
                        replace: true
                    });
                }

                next();
            } else {
                next('/nopermission');
            }
        } catch (error) {
            next();
        } finally {
            loadGlobal.closeLoading();
        }
    })
    return router
}
